import { KeyCutter } from '@mews-commander/data-access';

export const areSomeKeyCuttersUsable = ({
    keyCutters,
    isCheckedIn,
}: {
    keyCutters: KeyCutter[];
    isCheckedIn: boolean;
}): boolean => {
    if (keyCutters.length === 0) {
        return false;
    }

    if (isCheckedIn) {
        return true;
    }

    return keyCutters.some((keyCutter) => !keyCutter.requiresCheckIn);
};

export const isEveryKeyCutterUsable = ({
    keyCutters,
    isCheckedIn,
}: {
    keyCutters: KeyCutter[];
    isCheckedIn: boolean;
}): boolean => {
    if (keyCutters.length === 0) {
        return false;
    }

    if (isCheckedIn) {
        return true;
    }

    return keyCutters.every((keyCutter) => !keyCutter.requiresCheckIn);
};

export const isKeyCutterUsable = ({
    keyCutterId,
    keyCutters,
    isCheckedIn,
}: {
    keyCutterId: string;
    keyCutters: KeyCutter[];
    isCheckedIn: boolean;
}): boolean => {
    if (isCheckedIn) {
        return true;
    }

    const keyCutter = keyCutters.find((cutter) => cutter.id === keyCutterId);

    if (keyCutter == null) {
        return true;
    }

    const { requiresCheckIn } = keyCutter;
    return requiresCheckIn == null || requiresCheckIn === false;
};
